import Card from "@mui/joy/Card";
import React, { useRef } from "react";
import ModalClose from "@mui/joy/ModalClose";
import Box from "@mui/joy/Box";

const ModalWrapper = ({ open, closeModal, content, width = '300px', height = "auto" ,right='1%' ,top="calc(0% + 112px)",overflow='auto' }) => {
    const modalRef = useRef(null);

    return (
        <>
            {open && (
                <Card
                    ref={modalRef}
                    data-resizable
                    sx={{
                        position: "fixed",
                        right: right,
                        top: top,
                        p: 2,
                        zIndex: 1000,
                        alignItems: "center",
                        width: width,  
                        height: height,  
                        overflow: overflow
                    }}
                >
                    <Box sx={{ mb: 1 }} onClick={closeModal}>
                        <ModalClose />
                    </Box>
                    {content}
                </Card>
            )}
        </>
    );
};

export default ModalWrapper;
